// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// export const fetchUsers = createAsyncThunk("user/fetchUsers", async (_, { rejectWithValue }) => {
//   try {
//     const token = localStorage.getItem("vedhvidhi-admin-token");
//     const response = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/adminUsers`, {
//       headers: {
//         Authorization: token,
//       },
//     });
//     return response.data?.data || [];
//   } catch (error) {
//     return rejectWithValue(error.response?.data?.message || "Failed to fetch users");
//   }
// });

// const userSlice = createSlice({
//   name: "user",
//   initialState: {
//     users: [],
//     loading: false,
//     error: null,
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUsers.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchUsers.fulfilled, (state, action) => {
//         state.loading = false;
//         state.users = action.payload;
//       })
//       .addCase(fetchUsers.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default userSlice.reducer;


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching users with server-side pagination
export const fetchUsers = createAsyncThunk(
  "user/fetchUsers",
  async ({ page = 1, limit = 10 } = {}, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/adminUsers?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: token },
        }
      );

      return {
        users: response.data.data || [],
        pagination: response.data.paginationDetail || {},
      };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch users");
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    users: [],
    loading: false,
    error: null,
    page: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
        state.page = action.payload.pagination.page || 1;
        state.limit = action.payload.pagination.limit || 10;
        state.totalDocs = action.payload.pagination.totalDocs || 0;
        state.totalPages = action.payload.pagination.totalPages || 1;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;
